import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRelated = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.98047 0.511719C9.03674 0.619191 9.87564 1.45738 9.98633 2.5127C9.90864 2.50459 9.82983 2.5 9.75 2.5H8.97461C8.85876 1.92948 8.35471 1.5 7.75 1.5H2.25C1.55964 1.5 1 2.05964 1 2.75V7.25C1 7.85471 1.42948 8.35876 2 8.47461V9.25C2 9.32983 2.00459 9.40864 2.0127 9.48633C0.881667 9.3677 0 8.41244 0 7.25V2.75C0 1.58517 0.885159 0.627137 2.01953 0.511719L2.25 0.5H7.75L7.98047 0.511719Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 10.5V11.5H4.25V10.5H9.75ZM11 9.25V4.75C11 4.05964 10.4404 3.5 9.75 3.5H4.25C3.55964 3.5 3 4.05964 3 4.75V9.25C3 9.94036 3.55964 10.5 4.25 10.5V11.5C3.00736 11.5 2 10.4926 2 9.25V4.75C2 3.58517 2.88516 2.62714 4.01953 2.51172L4.25 2.5H9.75L9.98047 2.51172C11.1148 2.62714 12 3.58517 12 4.75V9.25C12 10.4926 10.9926 11.5 9.75 11.5V10.5C10.4404 10.5 11 9.94036 11 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.0459 5.14651C9.24116 4.95125 9.55864 4.95125 9.75391 5.14651C9.94885 5.34171 9.94885 5.65834 9.75391 5.85354L6.75391 8.85354C6.66024 8.94721 6.53285 8.99992 6.40039 9.00003C6.26789 9.00003 6.14062 8.94716 6.04688 8.85354L4.64648 7.45315C4.4514 7.25788 4.45128 6.94132 4.64648 6.74612C4.8417 6.5511 5.1583 6.5511 5.35352 6.74612L6.39941 7.79202L9.0459 5.14651Z",
			fill: "currentColor"
		})
	]
});
export default SvgRelated;
